
import { useEffect, useState } from 'react'
import { SickLeavePopUp } from '../ApplicationPopUps'
import { CustomerApplication } from '../../../utilities/CustomerData'

import infoIcon from '../../../assets/ApplicationIcons/infoIcon.png'
import estimateRefundIcon from '../../../assets/ApplicationIcons/estimateRefundIcon.png'

import '../../../css/CustomCalender.css'

export function ApplicationStep4({ _customerApplication, estimateRefund, step, setStep, handleApplicationStep4, handleSetApplicationStep4 }) {
  const customerApplication = new CustomerApplication(_customerApplication)

  const [childUnder18, setChildUnder18] = useState(customerApplication.childUnder18)
  const [taxCreditChildJanuary, setTaxCreditChildJanuary] = useState(customerApplication.taxCreditChildJanuary)
  const [taxCreditChildApril, setTaxCreditChildApril] = useState(customerApplication.taxCreditChildApril)
  const [filingStatus, setFilingStatus] = useState(customerApplication.filingStatus)
  const [showSickLeavePopup, setShowSickLeavePopup] = useState(false)
  const [showImportant, setShowImportant] = useState(false)

  useEffect(() => {
    handleSetApplicationStep4(taxCreditChildJanuary, taxCreditChildApril)
  }, [taxCreditChildJanuary, taxCreditChildApril])

  return (
    <div className='w-full flex justify-center'>
      <div className='lg:w-1/2 w-11/12 h-full flex flex-col items-center lg:justify-center mt-10 mb-10'>
        {estimateRefund > 0 && (
          <div className='mr-auto h-fit p-6 rounded-lg shadow-lg bg-gray-50 flex items-center gap-4 mb-4'>
            <div className='w-12 h-12 flex items-center justify-center rounded-full bg-secondaryColor object-contain'>
              <img 
                className='w-8 h-8' 
                src={estimateRefundIcon} 
                alt='Estimate Icon' 
              />
            </div>
            <div className='flex flex-col'>
              <p className='text-gray-600 text-sm font-medium'>Current Estimate</p>
              <p className='text-xl font-bold text-gray-900'>
                ${Number(estimateRefund).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </p>
            </div>
          </div>
        )}
        <p className='font-bold text-3xl text-setcb'>Sick Leave Tax Credit (You)</p>
        <p className='font-bold lg:text-2xl text-xl text-setcg mb-4'>$511 Daily Maximum Credit</p>
        <div className='w-full gap-4'>
          <div className='rounded-lg shadow-lg p-4 mb-10'>
            <p>Did you take care of a child under the age of 18 in 2021?</p>
            <div className='flex flex-row items-center gap-4 mt-2 mb-10'>
              <button onClick={() => setChildUnder18('Yes')} className={`w-24 py-2 ${childUnder18 === 'Yes' ? 'bg-primaryDarkColor text-white' : 'hover:bg-primaryColor hover:text-white border-[1px] text-black'} rounded-md`}>
                Yes
              </button>
              <button onClick={() => { setChildUnder18('No'); setTaxCreditChildJanuary(0); setTaxCreditChildApril(0) }} className={`w-24 py-2 ${childUnder18 === 'No' ? 'bg-primaryDarkColor text-white' : 'hover:bg-primaryColor hover:text-white border-[1px] text-black'} rounded-md`}>
                No
              </button>
            </div>
            {childUnder18 === 'Yes' && (
              <div className='mb-10'>
                <p className='font-bold text-xl mb-5'>Child Tax Credit</p>
                <p className='text-setcg font-bold text-lg'>Up to $200 per day claimed</p>
                <p>Select the amount of days you were unable to work because your child was out sick, was told to quarantine, or your child's school or daycare closed due to COVID 19. You do not need to delare exact days.</p>
                <p className='mt-4'>January 1, 2021 through March 31, 2021 <span className='font-bold'>(up to 10)</span></p>
                <div className='relative flex items-center gap-4 mt-12'>
                  <span className='text-gray-700'>0 days</span>
                  <input
                    type='range'
                    id='dateSlider'
                    min='0'
                    max='10'
                    step='1'
                    value={taxCreditChildJanuary}
                    onChange={(e) => setTaxCreditChildJanuary(Number(e.target.value))}
                    className='w-64 h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
                    style={{
                      background: `linear-gradient(to right, #74be43 ${((taxCreditChildJanuary / 10) * 100)}%, #ddd ${((taxCreditChildJanuary / 10) * 100)}%)`,
                    }}
                  />
                  <div className='absolute -top-8 left-40'>
                    <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
                      {taxCreditChildJanuary} days
                    </span>
                  </div>
                  <span className='text-gray-700'>10 days</span>
                </div>
                <p className='mt-10'>April 1, 2021 through September 30, 2021 <span className='font-bold'>(up to 10)</span></p>
                <div className='relative flex items-center gap-4 mt-12'>
                  <span className='text-gray-700'>0 days</span>
                  <input
                    type='range'
                    id='dateSlider'
                    min='0'
                    max='10'
                    step='1'
                    value={taxCreditChildApril}
                    onChange={(e) => setTaxCreditChildApril(Number(e.target.value))}
                    className='w-64 h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
                    style={{
                      background: `linear-gradient(to right, #74be43 ${((taxCreditChildApril / 10) * 100)}%, #ddd ${((taxCreditChildApril / 10) * 100)}%)`,
                    }}
                  />
                  <div className='absolute -top-8 left-40'>
                    <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
                      {taxCreditChildApril} days
                    </span>
                  </div>
                  <span className='text-gray-700'>10 days</span>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className='w-full bg-emerald-100 p-4 rounded-lg mb-4'>
          <div onClick={() => setShowImportant(!showImportant)} className='cursor-pointer flex flex-row items-center gap-2'>
            <img className='w-6' src={infoIcon} alt='Info Icon' />
            <p className='font-bold'>Important</p>
            <p className='ml-auto text-setcg'>{showImportant ? 'Collapse' : 'Expand'}</p>
          </div>
          {showImportant && (
            <div className='mt-4'>
              <p className='text-gray-600 mb-6'>You are required to affirm in <span className='text-setcg font-bold'>GOOD FAITH</span> that you were unable to work due to COVID-19. No additional documentation is required when submitting your filing; however, please retain any records demonstrating days missed.</p>
              <p className='text-gray-600'>Please note, any days claimed for unemployment benefits cannot be selected here.</p>
            </div>
          )}
        </div>
        <div className='flex flex-row items-center gap-4'>
          <button
            onClick={() => setStep(step - 1)}
            className='flex flex-row items-center gap-2 px-8 py-2 text-white rounded-md transition duration-200 mb-4 bg-red-500 hover:bg-red-600'
          >
            Back
          </button>
          <button
            disabled={!childUnder18}
            onClick={() => handleApplicationStep4(childUnder18, filingStatus, taxCreditChildJanuary, taxCreditChildApril)}
            className={`flex flex-row items-center gap-2 px-8 py-2 text-white rounded-md transition-colors duration-200 mb-4 ${!childUnder18 ? 'bg-gray-400 cursor-not-allowed' : 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200'}`}
          >
            Next
          </button>
        </div>
      </div>
      {showSickLeavePopup && (
        <SickLeavePopUp
          setShowSickLeavePopup={setShowSickLeavePopup}
        />
      )}
    </div>
  )
}

/**
 * <p>Are you filing single or married filing jointly?</p>
            <div className='flex flex-row items-center gap-4 mt-2'>
              <button onClick={() => setFilingStatus('Single')} className={`p-2 ${filingStatus === 'Single' ? 'bg-blue-500 hover:bg-blue-600 text-white' : 'hover:bg-blue-400 hover:text-white border-[1px] text-black'} rounded-md`}>
                Single Filing
              </button>
              <button onClick={() => setFilingStatus('MFJ')} className={`p-2 ${filingStatus === 'MFJ' ? 'bg-blue-500 hover:bg-blue-600 text-white' : 'hover:bg-blue-400 hover:text-white border-[1px] text-black'} rounded-md`}>
                Married Filing Jointly
              </button>
            </div>
 */